export function initYoutube() {
    const row = document.querySelector('#youtube-videos');
    const prev = document.querySelector('.yt-prev');
    const next = document.querySelector('.yt-next');
    if (!row || !prev || !next) return;

    const step = () => Math.max(row.clientWidth * 0.9, 300);

    prev.addEventListener('click', () => {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
        row.scrollBy({ left: step(), behavior: 'smooth' });
    });
}


/**
 * Optional: YouTube-style dots (no inertia needed)
 */
export function initRowDots() {
    const container = document.querySelector('#youtube-videos');
    const dots = document.querySelector('#youtube-dots');
    if (!container || !dots) return;

    function rebuild() {
        const pages = Math.ceil(container.scrollWidth / container.clientWidth);
        dots.innerHTML = '';

        if (pages <= 1) {
            dots.style.display = 'none';
            return;
        }

        dots.style.display = '';
        for (let i = 0; i < pages; i++) {
            const btn = document.createElement('button');
            btn.setAttribute('aria-label', `slide-dot ${i + 1}`);
            
            if (i === 0) btn.classList.add('active');
            btn.addEventListener('click', () => {
                container.scrollTo({ left: i * container.clientWidth, behavior: 'smooth' });
            });
            dots.appendChild(btn);
        }

        const all = dots.querySelectorAll('button');
        container.addEventListener('scroll', () => {
            const idx = Math.round(container.scrollLeft / container.clientWidth);
            all.forEach((b, i) => b.classList.toggle('active', i === idx));
        }, { passive: true });
    }

    rebuild();
    let t;
    window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(rebuild, 200);
    });
}
